module.exports = __webpack_public_path__ + "static/media/cuteCut-01.710e0282.png";